import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9cd59092"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "general_tab",
  class: "my-6"
}
const _hoisted_2 = { class: "tab-wrapper-primary mb-6" }
const _hoisted_3 = { class: "tab-heading-primary" }
const _hoisted_4 = { class: "flex flex-col gap-4 p-6" }
const _hoisted_5 = { class: "w-full pt-2" }
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = {
  class: "label-primary",
  for: ""
}
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "absolute top-3.5 right-3" }
const _hoisted_11 = { class: "mt-1 text-xs text-critical-main" }
const _hoisted_12 = { class: "w-full pt-2" }
const _hoisted_13 = { class: "relative" }
const _hoisted_14 = {
  class: "label-primary",
  for: ""
}
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "absolute top-3.5 right-3" }
const _hoisted_18 = { class: "mt-1 text-xs text-critical-main" }
const _hoisted_19 = { class: "tab-wrapper-primary mb-6 transition-all ease-in-out duration-300" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tab-heading-primary" }, "Specials", -1))
const _hoisted_21 = { class: "relative flex flex-col gap-4 p-6" }
const _hoisted_22 = { class: "max-w-[300px] pt-2" }
const _hoisted_23 = { class: "pl-[46px]" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "block mb-2 text-sm font-normal text-secondary" }, "Matrix", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-2 border-t-[1px] border-dashed" }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "block mb-2 text-sm font-normal text-secondary" }, "Search, Search & Matrix", -1))
const _hoisted_27 = { class: "mb-2" }
const _hoisted_28 = { class: "mb-4" }
const _hoisted_29 = { class: "max-w-[700px]" }
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = {
  ref: "bookingAndPayments",
  class: "tab-wrapper-primary mt-6 transition-all"
}
const _hoisted_32 = { class: "tab-heading-primary" }
const _hoisted_33 = { class: "relative flex flex-col gap-4 p-6" }
const _hoisted_34 = { class: "w-full pt-2" }
const _hoisted_35 = { class: "relative" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "contact-email",
  class: "label-primary"
}, " E-mail or URL for \"Contact us\" ", -1))
const _hoisted_37 = ["placeholder"]
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "absolute top-3.5 right-3" }
const _hoisted_40 = { class: "mt-1 text-xs text-critical-main" }
const _hoisted_41 = { class: "flex items-center gap-1" }
const _hoisted_42 = { class: "w-full py-2" }
const _hoisted_43 = { class: "relative" }
const _hoisted_44 = {
  for: "cc-email",
  class: "label-primary"
}
const _hoisted_45 = ["placeholder"]
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { class: "absolute top-3.5 right-3" }
const _hoisted_48 = { class: "mt-1 text-xs text-critical-main" }
const _hoisted_49 = { class: "flex gap-4" }
const _hoisted_50 = { class: "w-full pt-2" }
const _hoisted_51 = { class: "relative" }
const _hoisted_52 = {
  class: "label-primary",
  for: "person-name"
}
const _hoisted_53 = ["placeholder"]
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { class: "absolute top-3.5 right-3" }
const _hoisted_56 = { class: "mt-1 text-xs text-critical-main" }
const _hoisted_57 = { class: "w-full pt-2" }
const _hoisted_58 = { class: "relative" }
const _hoisted_59 = {
  for: "originating-email",
  class: "label-primary"
}
const _hoisted_60 = ["placeholder"]
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { class: "absolute top-3.5 right-3" }
const _hoisted_63 = { class: "mt-1 text-xs text-critical-main" }
const _hoisted_64 = { class: "w-full pt-4 mb-4" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border border-dashed border-neutral-50" }, null, -1))
const _hoisted_66 = { class: "relative mt-4" }
const _hoisted_67 = {
  for: "additional-links-heading",
  class: "label-primary"
}
const _hoisted_68 = ["placeholder"]
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { class: "absolute top-3.5 right-3" }
const _hoisted_71 = { class: "mt-1 text-xs text-critical-main" }
const _hoisted_72 = { class: "flex flex-col gap-2 mb-2" }
const _hoisted_73 = { class: "text-base font-medium text-neutral-125" }
const _hoisted_74 = { class: "flex items-center gap-2" }
const _hoisted_75 = ["aria-pressed"]
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "4",
    y: "5",
    width: "12",
    height: "2",
    rx: "1",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "4",
    y: "9",
    width: "12",
    height: "2",
    rx: "1",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "4",
    y: "13",
    width: "12",
    height: "2",
    rx: "1",
    fill: "currentColor"
  })
], -1))
const _hoisted_77 = [
  _hoisted_76
]
const _hoisted_78 = ["aria-pressed"]
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "5",
    y: "8",
    width: "2",
    height: "4",
    rx: "1",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "9",
    y: "8",
    width: "2",
    height: "4",
    rx: "1",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "13",
    y: "8",
    width: "2",
    height: "4",
    rx: "1",
    fill: "currentColor"
  })
], -1))
const _hoisted_80 = [
  _hoisted_79
]
const _hoisted_81 = { class: "flex items-center justify-between mb-4" }
const _hoisted_82 = { class: "text-base font-medium text-neutral-125" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8 3C8.55228 3 9 3.44772 9 4V7H12C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9H9V12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12V9H4C3.44772 9 3 8.55228 3 8C3 7.44772 3.44772 7 4 7H7V4C7 3.44772 7.44772 3 8 3Z" })
], -1))
const _hoisted_84 = {
  key: 0,
  class: "flex flex-col gap-4"
}
const _hoisted_85 = { class: "flex items-center justify-between" }
const _hoisted_86 = { class: "text-sm font-medium text-neutral-125" }
const _hoisted_87 = ["onClick", "title"]
const _hoisted_88 = { class: "w-4 h-4" }
const _hoisted_89 = { class: "flex gap-4" }
const _hoisted_90 = { class: "w-1/2 pt-2" }
const _hoisted_91 = { class: "relative" }
const _hoisted_92 = ["for"]
const _hoisted_93 = ["id", "onUpdate:modelValue", "placeholder", "onChange", "onBlur"]
const _hoisted_94 = {
  key: 0,
  class: "absolute top-3.5 right-3"
}
const _hoisted_95 = {
  key: 0,
  class: "mt-1 text-xs text-critical-main"
}
const _hoisted_96 = { class: "w-1/2 pt-2" }
const _hoisted_97 = { class: "relative" }
const _hoisted_98 = ["for"]
const _hoisted_99 = ["id", "onUpdate:modelValue", "placeholder", "onChange", "onBlur"]
const _hoisted_100 = {
  key: 0,
  class: "absolute top-3.5 right-3"
}
const _hoisted_101 = {
  key: 0,
  class: "mt-1 text-xs text-critical-main"
}
const _hoisted_102 = {
  key: 0,
  class: "w-full pt-2"
}
const _hoisted_103 = { class: "relative" }
const _hoisted_104 = ["for"]
const _hoisted_105 = ["id", "onUpdate:modelValue", "placeholder", "onChange", "onBlur"]
const _hoisted_106 = {
  key: 0,
  class: "absolute top-3.5 right-3"
}
const _hoisted_107 = {
  key: 0,
  class: "mt-1 text-xs text-critical-main"
}
const _hoisted_108 = {
  key: 1,
  class: "text-center py-8 text-neutral-100"
}
const _hoisted_109 = { class: "text-sm" }
const _hoisted_110 = { class: "flex flex-col gap-4" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border border-dashed border-neutral-50" }, null, -1))
const _hoisted_112 = {
  key: 0,
  class: "flex gap-4 pt-4"
}
const _hoisted_113 = {
  key: 1,
  class: "flex gap-4 pt-4"
}
const _hoisted_114 = { class: "flex gap-4" }
const _hoisted_115 = { class: "flex items-center gap-2" }
const _hoisted_116 = { class: "flex justify-center items-center w-5 h-5 rounded-md border border-white hover:border-neutral-100 transition-all cursor-pointer" }
const _hoisted_117 = ["checked"]
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "aviable_p",
  class: "text-xs font-medium text-neutral-125 dark:text-gray-300 cursor-pointer"
}, " Allow users to book now and pay later ", -1))
const _hoisted_119 = { class: "flex items-center gap-2 cursor-pointer" }
const _hoisted_120 = { class: "flex justify-center items-center w-5 h-5 rounded-md border border-white hover:border-neutral-100 transition-all cursor-pointer" }
const _hoisted_121 = ["checked"]
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "aviable_full_pay",
  class: "text-xs font-medium text-neutral-125 dark:text-gray-300 cursor-pointer"
}, " Allow users to 100% upfront regardless of the payment plan ", -1))
const _hoisted_123 = { class: "pt-4 border-t border-dashed border-neutral-50 transition-all ease-in-out duration-300" }
const _hoisted_124 = { class: "max-w-[300px] pt-4" }
const _hoisted_125 = { class: "max-w-[700px] pt-2" }
const _hoisted_126 = ["innerHTML"]
const _hoisted_127 = {
  key: 0,
  class: "tab-wrapper-primary mt-6"
}
const _hoisted_128 = { class: "tab-heading-primary" }
const _hoisted_129 = { class: "p-6" }
const _hoisted_130 = { class: "pt-3" }
const _hoisted_131 = {
  key: 0,
  class: "text-xs text-neutral-100"
}
const _hoisted_132 = { key: 1 }
const _hoisted_133 = { class: "flex items-center justify-between mb-1" }
const _hoisted_134 = {
  class: "label-primary",
  for: "custom-terms"
}
const _hoisted_135 = {
  key: 0,
  class: "text-xs text-neutral-100 py-4"
}
const _hoisted_136 = ["placeholder"]
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-xs text-neutral-100" }, " HTML is supported for formatting (e.g. <b>bold</b>, <ul><li>lists</li></ul>, <a href=\"...\">links</a>). ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NotificationPopup = _resolveComponent("NotificationPopup")!
  const _component_ErrorIcon = _resolveComponent("ErrorIcon")!
  const _component_CheckboxSlide = _resolveComponent("CheckboxSlide")!
  const _component_OverlaySpinner = _resolveComponent("OverlaySpinner")!
  const _component_QuestionMarkIcon = _resolveComponent("QuestionMarkIcon")!
  const _component_BaseTooltip = _resolveComponent("BaseTooltip")!
  const _component_TrashCanIcon = _resolveComponent("TrashCanIcon")!
  const _component_PaymentDropdown = _resolveComponent("PaymentDropdown")!
  const _component_PaymentTextInput = _resolveComponent("PaymentTextInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_NotificationPopup, {
      status: "warning",
      title: "Changes Unpublished",
      text: "To view your updates on the widget, please save and publish them.",
      class: "mb-6"
    }, null, 512), [
      [_vShow, _ctx.widget.edited]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.changeCase('widget name & description', _ctx.ElementE.TITLE)), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.changeCase('widget name', _ctx.ElementE.LABEL)), 1),
            _withDirectives(_createElementVNode("input", {
              onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveWidgetName(_ctx.widget.name as string))),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.widget.name) = $event)),
              class: _normalizeClass(["input-primary", _ctx.errors.widgetName && 'border-critical']),
              type: "text",
              placeholder: (_ctx.changeCase('enter name', _ctx.ElementE.PLACEHOLDER) as string)
            }, null, 42, _hoisted_8), [
              [
                _vModelText,
                _ctx.widget.name,
                void 0,
                { trim: true }
              ]
            ]),
            (_ctx.errors.widgetName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_ErrorIcon)
                  ]),
                  _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.errors.widgetName), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.changeCase('widget description', _ctx.ElementE.LABEL)), 1),
            _withDirectives(_createElementVNode("textarea", {
              onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveWidgetDescription(_ctx.widget.description as string))),
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.widget.description) = $event)),
              class: _normalizeClass(["input-primary block", 
                _ctx.errors.widgetDescription && 'border-critical'
              ]),
              placeholder: (_ctx.changeCase('enter description', _ctx.ElementE.PLACEHOLDER) as string)
            }, null, 42, _hoisted_15), [
              [
                _vModelText,
                _ctx.widget.description,
                void 0,
                { trim: true }
              ]
            ]),
            (_ctx.errors.widgetDescription)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_ErrorIcon)
                  ]),
                  _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.errors.widgetDescription), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _hoisted_20,
      _createElementVNode("div", _hoisted_21, [
        (_openBlock(), _createBlock(_component_CheckboxSlide, {
          key: _ctx.apiCallExist.specials.toString(),
          isChecked: _ctx.apiCallExist.specials,
          disabled: _ctx.apiCallExist.specials || _ctx.isSpecialsLoading,
          tooltipTxt: _ctx.apiCallExist.specials ? 'Specials already activated' : 'Specials not activated yet',
          label: "Activate specials",
          "onUpdate:isChecked": _ctx.activateSpecials
        }, null, 8, ["isChecked", "disabled", "tooltipTxt", "onUpdate:isChecked"])),
        _withDirectives(_createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", null, [
            _createVNode(_component_CheckboxSlide, {
              isChecked: _ctx.specials.enabled,
              disabled: !_ctx.apiCallExist?.specials,
              label: "Enable specials",
              class: "pb-2",
              "onUpdate:isChecked": _cache[4] || (_cache[4] = ($event: any) => (_ctx.enableSpecials($event, 'enabled')))
            }, null, 8, ["isChecked", "disabled"]),
            _createVNode(_Transition, null, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("div", null, [
                    _createVNode(_component_CheckboxSlide, {
                      label: "Above matrix date selection",
                      disabled: !_ctx.apiCallExist?.specials,
                      isChecked: _ctx.specials.above_matrix,
                      "onUpdate:isChecked": _cache[5] || (_cache[5] = ($event: any) => (_ctx.enableSpecials($event, 'above_matrix')))
                    }, null, 8, ["disabled", "isChecked"])
                  ]),
                  _hoisted_25,
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_CheckboxSlide, {
                      label: "Near search bar",
                      disabled: !_ctx.apiCallExist?.specials,
                      isChecked: _ctx.specials.near_search,
                      "onUpdate:isChecked": _cache[6] || (_cache[6] = ($event: any) => (_ctx.enableSpecials($event, 'near_search')))
                    }, null, 8, ["disabled", "isChecked"])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_CheckboxSlide, {
                      label: "Between search results",
                      disabled: !_ctx.apiCallExist?.specials,
                      isChecked: _ctx.specials.between_available,
                      "onUpdate:isChecked": _cache[7] || (_cache[7] = ($event: any) => (_ctx.enableSpecials($event, 'between_available')))
                    }, null, 8, ["disabled", "isChecked"])
                  ])
                ], 512), [
                  [_vShow, _ctx.specials.enabled]
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_CheckboxSlide, {
              label: "Enable 'Only 1 left'",
              isChecked: _ctx.specials.only_one_left,
              "onUpdate:isChecked": _cache[8] || (_cache[8] = ($event: any) => (_ctx.enableSpecials($event, 'only_one_left')))
            }, null, 8, ["isChecked"])
          ])
        ], 512), [
          [_vShow, _ctx.apiCallExist.specials && !_ctx.isSpecialsLoading]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_29, [
          _createElementVNode("p", {
            innerHTML: _ctx.specialsErrorMessage,
            class: "text-sm"
          }, null, 8, _hoisted_30)
        ], 512), [
          [_vShow, _ctx.isSpecialsNotValid]
        ]),
        (_ctx.isSpecialsLoading)
          ? (_openBlock(), _createBlock(_component_OverlaySpinner, { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.changeCase('bookings & payments', _ctx.ElementE.TITLE)), 1),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.contactEmailFieldValue) = $event)),
              id: "contact-email",
              type: "text",
              class: _normalizeClass(["input-primary", _ctx.errors.contactEmail && 'border-critical']),
              placeholder: (_ctx.changeCase('enter e-mail or url', _ctx.ElementE.PLACEHOLDER) as string),
              onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.saveContactEmail(_ctx.contactEmailFieldValue))),
              onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.validateEmail('contactEmail', _ctx.contactEmailFieldValue)))
            }, null, 42, _hoisted_37), [
              [
                _vModelText,
                _ctx.contactEmailFieldValue,
                void 0,
                { trim: true }
              ]
            ]),
            (_ctx.errors.contactEmail)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createVNode(_component_ErrorIcon)
                  ]),
                  _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.errors.contactEmail), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createVNode(_component_CheckboxSlide, {
            onClick: _ctx.bookingEnable,
            label: "Enable bookings",
            info: "some info",
            isChecked: _ctx.isBookingChecked
          }, null, 8, ["onClick", "isChecked"]),
          _createVNode(_component_BaseTooltip, { tooltipText: "For ResNova bookings to be confirmed successfuly in ResRequest, the ResRequest User Access Permissions for the ResNova user must allow Status Changes: 'Non-stock holding to Stock holding'" }, {
            icon: _withCtx(() => [
              _createVNode(_component_QuestionMarkIcon)
            ]),
            _: 1
          })
        ]),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.changeCase('send a copy of a booking e-mail to...', _ctx.ElementE.LABEL)), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.ccEmailsFieldValue) = $event)),
                    id: "cc-email",
                    type: "text",
                    class: _normalizeClass(["input-primary", 
                  _ctx.errors.ccEmails && 'border-critical'
                ]),
                    placeholder: (_ctx.changeCase('enter e-mail', _ctx.ElementE.PLACEHOLDER) as string),
                    onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.saveCcEmails(_ctx.ccEmailsFieldValue))),
                    onBlur: _cache[14] || (_cache[14] = ($event: any) => (
                  _ctx.validateEmail('ccEmails', _ctx.ccEmailsFieldValue)
                ))
                  }, null, 42, _hoisted_45), [
                    [
                      _vModelText,
                      _ctx.ccEmailsFieldValue,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (_ctx.errors.ccEmails)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _createVNode(_component_ErrorIcon)
                        ]),
                        _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.errors.ccEmails), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.changeCase('name', _ctx.ElementE.LABEL)), 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.personNameFieldValue) = $event)),
                      id: "person-name",
                      type: "text",
                      class: _normalizeClass(["input-primary", _ctx.errors.personName && 'border-critical']),
                      placeholder: (_ctx.changeCase('name from which the e-mail originates', _ctx.ElementE.PLACEHOLDER) as string),
                      onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.saveName(_ctx.personNameFieldValue))),
                      onBlur: _cache[17] || (_cache[17] = ($event: any) => (_ctx.validateField('personName', _ctx.personNameFieldValue)))
                    }, null, 42, _hoisted_53), [
                      [
                        _vModelText,
                        _ctx.personNameFieldValue,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    (_ctx.errors.personName)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                          _createElementVNode("div", _hoisted_55, [
                            _createVNode(_component_ErrorIcon)
                          ]),
                          _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.errors.personName), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.changeCase('e-mail', _ctx.ElementE.LABEL)), 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.originatingEmailFieldValue) = $event)),
                      id: "originating-email",
                      type: "text",
                      class: _normalizeClass(["input-primary", 
                    _ctx.errors.originatingEmail && 'border-critical'
                  ]),
                      placeholder: (_ctx.changeCase('the originating e-mail address', _ctx.ElementE.PLACEHOLDER) as string),
                      onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.saveOriginatingEmail(_ctx.originatingEmailFieldValue))),
                      onBlur: _cache[20] || (_cache[20] = ($event: any) => (
                    _ctx.validateEmail('originatingEmail', _ctx.originatingEmailFieldValue)
                  ))
                    }, null, 42, _hoisted_60), [
                      [
                        _vModelText,
                        _ctx.originatingEmailFieldValue,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    (_ctx.errors.originatingEmail)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                          _createElementVNode("div", _hoisted_62, [
                            _createVNode(_component_ErrorIcon)
                          ]),
                          _createElementVNode("p", _hoisted_63, _toDisplayString(_ctx.errors.originatingEmail), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_64, [
                _hoisted_65,
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("label", _hoisted_67, _toDisplayString(_ctx.changeCase('additional email links heading', _ctx.ElementE.LABEL)), 1),
                  _withDirectives(_createElementVNode("input", {
                    id: "additional-links-heading",
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.additionalEmailLinksHeading) = $event)),
                    type: "text",
                    class: _normalizeClass(["input-primary", _ctx.errors.additionalEmailLinksHeading && 'border-critical']),
                    placeholder: (_ctx.changeCase('additional email links heading', _ctx.ElementE.PLACEHOLDER) as string),
                    onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.saveAdditionalEmailLinksHeading(_ctx.additionalEmailLinksHeading))),
                    onBlur: _cache[23] || (_cache[23] = ($event: any) => (_ctx.validateField('additionalEmailLinksHeading', _ctx.additionalEmailLinksHeading)))
                  }, null, 42, _hoisted_68), [
                    [
                      _vModelText,
                      _ctx.additionalEmailLinksHeading,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (_ctx.errors.additionalEmailLinksHeading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                        _createElementVNode("div", _hoisted_70, [
                          _createVNode(_component_ErrorIcon)
                        ]),
                        _createElementVNode("p", _hoisted_71, _toDisplayString(_ctx.errors.additionalEmailLinksHeading), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("h4", _hoisted_73, _toDisplayString(_ctx.changeCase('Additional links layout', _ctx.ElementE.TITLE)), 1),
                _createElementVNode("div", _hoisted_74, [
                  _createVNode(_component_BaseTooltip, { tooltipText: "List layout - Links will appear vertically stacked in the confirmation email" }, {
                    icon: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(['px-2 py-1 rounded border', _ctx.additionalEmailLinksLayout === 'list' ? 'bg-primary-main text-white border-primary-main' : 'bg-white text-primary-main border-primary-main']),
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.setAdditionalEmailLinksLayout('list'))),
                        "aria-pressed": _ctx.additionalEmailLinksLayout === 'list'
                      }, _hoisted_77, 10, _hoisted_75)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_BaseTooltip, { tooltipText: "Inline layout - Links will appear horizontally side by side in the confirmation email" }, {
                    icon: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(['px-2 py-1 rounded border', _ctx.additionalEmailLinksLayout === 'inline' ? 'bg-primary-main text-white border-primary-main' : 'bg-white text-primary-main border-primary-main']),
                        onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.setAdditionalEmailLinksLayout('inline'))),
                        "aria-pressed": _ctx.additionalEmailLinksLayout === 'inline'
                      }, _hoisted_80, 10, _hoisted_78)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("h4", _hoisted_82, _toDisplayString(_ctx.changeCase('links', _ctx.ElementE.TITLE)), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "flex items-center gap-2 px-3 py-2 text-sm font-medium text-primary-main bg-white border border-primary-main rounded-md hover:bg-primary-main hover:text-white transition-all",
                  onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.addEmailLink && _ctx.addEmailLink(...args)))
                }, [
                  _hoisted_83,
                  _createTextVNode(" " + _toDisplayString(_ctx.changeCase('add link', _ctx.ElementE.BUTTON)), 1)
                ])
              ]),
              (_ctx.additionalEmailLinks.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.additionalEmailLinks, (link, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: link.id,
                        class: "flex flex-col gap-x-4 gap-y-1 p-4 bg-gray-100 rounded-md"
                      }, [
                        _createElementVNode("div", _hoisted_85, [
                          _createElementVNode("h5", _hoisted_86, _toDisplayString(_ctx.changeCase(`link ${index + 1}`, _ctx.ElementE.TITLE)), 1),
                          _createElementVNode("button", {
                            type: "button",
                            class: "flex items-center justify-center w-5 h-5 text-gray-800 hover:bg-transparent hover:text-critical-main rounded-md transition-all",
                            onClick: ($event: any) => (_ctx.removeEmailLink(index)),
                            title: _ctx.changeCase('delete link', _ctx.ElementE.BUTTON) as string
                          }, [
                            _createElementVNode("div", _hoisted_88, [
                              _createVNode(_component_TrashCanIcon)
                            ])
                          ], 8, _hoisted_87)
                        ]),
                        _createElementVNode("div", _hoisted_89, [
                          _createElementVNode("div", _hoisted_90, [
                            _createElementVNode("div", _hoisted_91, [
                              _createElementVNode("label", {
                                for: `email-link-title-${link.id}`,
                                class: "label-primary"
                              }, _toDisplayString(_ctx.changeCase('title', _ctx.ElementE.LABEL)), 9, _hoisted_92),
                              _withDirectives(_createElementVNode("input", {
                                id: `email-link-title-${link.id}`,
                                "onUpdate:modelValue": ($event: any) => ((link.title) = $event),
                                type: "text",
                                class: _normalizeClass(["input-primary", link.errors?.title && 'border-critical']),
                                placeholder: (_ctx.changeCase('enter link title', _ctx.ElementE.PLACEHOLDER) as string),
                                onChange: ($event: any) => (_ctx.saveEmailLink(index, 'title', link.title)),
                                onBlur: ($event: any) => (_ctx.validateEmailLink(index, 'title', link.title))
                              }, null, 42, _hoisted_93), [
                                [
                                  _vModelText,
                                  link.title,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              (link.errors?.title)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                    _createVNode(_component_ErrorIcon)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            (link.errors?.title)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_95, _toDisplayString(link.errors.title), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_96, [
                            _createElementVNode("div", _hoisted_97, [
                              _createElementVNode("label", {
                                for: `email-link-url-${link.id}`,
                                class: "label-primary"
                              }, _toDisplayString(_ctx.changeCase('URL', _ctx.ElementE.LABEL)), 9, _hoisted_98),
                              _withDirectives(_createElementVNode("input", {
                                id: `email-link-url-${link.id}`,
                                "onUpdate:modelValue": ($event: any) => ((link.url) = $event),
                                type: "text",
                                class: _normalizeClass(["input-primary", link.errors?.url && 'border-critical']),
                                placeholder: (_ctx.changeCase('enter url', _ctx.ElementE.PLACEHOLDER) as string),
                                onChange: ($event: any) => (_ctx.saveEmailLink(index, 'url', link.url)),
                                onBlur: ($event: any) => (_ctx.validateEmailLink(index, 'url', link.url))
                              }, null, 42, _hoisted_99), [
                                [
                                  _vModelText,
                                  link.url,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              (link.errors?.url)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                    _createVNode(_component_ErrorIcon)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            (link.errors?.url)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_101, _toDisplayString(link.errors.url), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (_ctx.additionalEmailLinksLayout === 'list')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                              _createElementVNode("div", _hoisted_103, [
                                _createElementVNode("label", {
                                  for: `email-link-description-${link.id}`,
                                  class: "label-primary"
                                }, _toDisplayString(_ctx.changeCase('description', _ctx.ElementE.LABEL)), 9, _hoisted_104),
                                _withDirectives(_createElementVNode("textarea", {
                                  id: `email-link-description-${link.id}`,
                                  "onUpdate:modelValue": ($event: any) => ((link.description) = $event),
                                  class: _normalizeClass(["input-primary block", link.errors?.description && 'border-critical']),
                                  placeholder: (_ctx.changeCase('enter link description', _ctx.ElementE.PLACEHOLDER) as string),
                                  rows: "2",
                                  onChange: ($event: any) => (_ctx.saveEmailLink(index, 'description', link.description || '')),
                                  onBlur: ($event: any) => (_ctx.validateEmailLink(index, 'description', link.description || ''))
                                }, null, 42, _hoisted_105), [
                                  [
                                    _vModelText,
                                    link.description,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (link.errors?.description)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                                      _createVNode(_component_ErrorIcon)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              (link.errors?.description)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_107, _toDisplayString(link.errors.description), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_108, [
                    _createElementVNode("p", _hoisted_109, _toDisplayString(_ctx.changeCase('no additional email links added yet', _ctx.ElementE.PLACEHOLDER)), 1)
                  ]))
            ], 512), [
              [_vShow, _ctx.isBookingChecked]
            ])
          ]),
          _: 1
        }),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_110, [
              _hoisted_111,
              _createVNode(_component_CheckboxSlide, {
                onClick: _ctx.paymentEnable,
                id: "enablePayment",
                label: "Enable card payments",
                isChecked: _ctx.isPaymentChecked
              }, null, 8, ["onClick", "isChecked"]),
              (_ctx.isShowPaymentError)
                ? (_openBlock(), _createBlock(_component_NotificationPopup, {
                    key: 0,
                    status: "error",
                    title: "Payment Gateway Issue",
                    text: _ctx.errorTextWithSupportLink
                  }, null, 8, ["text"]))
                : _createCommentVNode("", true),
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_PaymentDropdown, {
                        onInput: _ctx.paymentSet,
                        label: "Payment gateway",
                        defaultId: "1",
                        defaultSelect: _ctx.paymentMethod,
                        values: _ctx.payments,
                        tab: "general"
                      }, null, 8, ["onInput", "defaultSelect", "values"])
                    ]),
                    (_ctx.isSimplePaymentField)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.widget.config
                  .payment_gateway_config, (names, key, index) => {
                            return (_openBlock(), _createBlock(_component_PaymentTextInput, {
                              dvalue: names,
                              value: names,
                              key: index,
                              id: key,
                              onInput: _ctx.savePaymentField,
                              "inp-value": names,
                              label: key,
                              placeholder: names
                            }, null, 8, ["dvalue", "value", "id", "onInput", "inp-value", "label", "placeholder"]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_113, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentFields, (pField) => {
                            return (_openBlock(), _createBlock(_component_PaymentTextInput, {
                              onInput: _ctx.savePaymentField,
                              dvalue: _ctx.getPaymentValue,
                              key: pField.id,
                              id: pField.field_name,
                              "inp-value": "",
                              label: pField.title,
                              placeholder: pField.title
                            }, null, 8, ["onInput", "dvalue", "id", "label", "placeholder"]))
                          }), 128))
                        ]))
                  ], 512), [
                    [_vShow, _ctx.isPaymentChecked]
                  ])
                ]),
                _: 1
              }),
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_114, [
                      _createElementVNode("div", _hoisted_115, [
                        _createElementVNode("span", _hoisted_116, [
                          _createElementVNode("input", {
                            value: "",
                            checked: _ctx.allowPayLater,
                            id: "aviable_p",
                            type: "checkbox",
                            class: "w-4 h-4 rounded-md text-neutral-100 border-neutral-100 focus:ring-0 focus:ring-offset-0 transition-all cursor-pointer",
                            onChange: _cache[27] || (_cache[27] = ($event: any) => (_ctx.payLater($event as HtmlEvent)))
                          }, null, 40, _hoisted_117)
                        ]),
                        _hoisted_118
                      ]),
                      _createElementVNode("div", _hoisted_119, [
                        _createElementVNode("span", _hoisted_120, [
                          _createElementVNode("input", {
                            value: "",
                            checked: _ctx.allowPayFull,
                            id: "aviable_full_pay",
                            type: "checkbox",
                            class: "w-4 h-4 rounded-md text-neutral-100 border-neutral-100 focus:ring-0 focus:ring-offset-0 transition-all cursor-pointer",
                            onChange: _cache[28] || (_cache[28] = ($event: any) => (_ctx.payFull($event as HtmlEvent)))
                          }, null, 40, _hoisted_121)
                        ]),
                        _hoisted_122
                      ])
                    ])
                  ], 512), [
                    [_vShow, _ctx.isPaymentChecked]
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("article", _hoisted_123, [
                (_openBlock(), _createBlock(_component_CheckboxSlide, {
                  key: _ctx.apiCallExist.extras.toString(),
                  isChecked: _ctx.apiCallExist.extras,
                  disabled: _ctx.apiCallExist.extras || _ctx.isExtrasLoading,
                  tooltipTxt: _ctx.apiCallExist.extras ? 'Extras already activated' : 'Extras not activated yet',
                  label: "Activate extras",
                  "onUpdate:isChecked": _ctx.activateExtras
                }, null, 8, ["isChecked", "disabled", "tooltipTxt", "onUpdate:isChecked"])),
                _withDirectives(_createElementVNode("div", _hoisted_124, [
                  _createVNode(_component_CheckboxSlide, {
                    isChecked: _ctx.extras.enabled,
                    disabled: !_ctx.apiCallExist.extras,
                    label: "Enable extras",
                    "onUpdate:isChecked": _cache[29] || (_cache[29] = ($event: any) => (_ctx.enableExtras($event, 'enabled')))
                  }, null, 8, ["isChecked", "disabled"]),
                  _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_CheckboxSlide, {
                        isChecked: _ctx.extras.is_grouped_by_category,
                        disabled: !_ctx.apiCallExist.extras,
                        class: "pt-4 pl-14",
                        label: "Group extras by category",
                        "onUpdate:isChecked": _cache[30] || (_cache[30] = ($event: any) => (_ctx.enableExtras($event, 'is_grouped_by_category')))
                      }, null, 8, ["isChecked", "disabled"]), [
                        [_vShow, _ctx.extras.enabled]
                      ])
                    ]),
                    _: 1
                  })
                ], 512), [
                  [_vShow, _ctx.apiCallExist.extras && !_ctx.isExtrasLoading]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_125, [
                  _createElementVNode("p", {
                    innerHTML: _ctx.extrasErrorMessage,
                    class: "text-sm"
                  }, null, 8, _hoisted_126)
                ], 512), [
                  [_vShow, _ctx.isExtrasNotValid]
                ])
              ])
            ], 512), [
              [_vShow, _ctx.isBookingChecked]
            ])
          ]),
          _: 1
        }),
        (_ctx.isExtrasLoading)
          ? (_openBlock(), _createBlock(_component_OverlaySpinner, { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ], 512),
    (_ctx.widget.config)
      ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
          _createElementVNode("div", _hoisted_128, _toDisplayString(_ctx.changeCase('terms and conditions', _ctx.ElementE.TITLE)), 1),
          _createElementVNode("div", _hoisted_129, [
            _createVNode(_component_CheckboxSlide, {
              label: "Use custom terms and conditions",
              isChecked: _ctx.widget.config?.custom_terms_enabled ?? false,
              "onUpdate:isChecked": _ctx.toggleCustomTerms
            }, null, 8, ["isChecked", "onUpdate:isChecked"]),
            _createElementVNode("div", _hoisted_130, [
              (!_ctx.widget.config?.custom_terms_enabled)
                ? (_openBlock(), _createElementBlock("p", _hoisted_131, " Default terms and conditions are pulled from ResRequest. "))
                : (_openBlock(), _createElementBlock("div", _hoisted_132, [
                    _createElementVNode("div", _hoisted_133, [
                      _createElementVNode("label", _hoisted_134, _toDisplayString(_ctx.changeCase('custom terms and conditions', _ctx.ElementE.LABEL)), 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: "text-xs text-red-600 hover:text-red-800 font-medium",
                        onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.confirmResetTerms && _ctx.confirmResetTerms(...args)))
                      }, " Reset to default ")
                    ]),
                    (_ctx.isTermsLoading)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_135, "Loading default terms..."))
                      : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                          key: 1,
                          id: "custom-terms",
                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.customTermsContent) = $event)),
                          class: "input-primary block h-40",
                          placeholder: (_ctx.changeCase('enter your custom terms and conditions...', _ctx.ElementE.PLACEHOLDER) as string),
                          onInput: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.setCustomTermsContent && _ctx.setCustomTermsContent(...args)))
                        }, null, 40, _hoisted_136)), [
                          [_vModelText, _ctx.customTermsContent]
                        ]),
                    _hoisted_137
                  ]))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}